"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAverageRating = void 0;
const getAverageRating = (reviews) => {
    if (!reviews)
        return 0;
    if (reviews.length === 0)
        return 0;
    const ratings = reviews.map((review) => review.overall);
    const sum = ratings.reduce((a, b) => a + b, 0);
    return Number((sum / ratings.length).toFixed(1));
};
exports.getAverageRating = getAverageRating;
